module.exports = __webpack_public_path__ + "static/media/app-store-nl.65070948.svg";